/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Items_Lot_Picker_PlaceholderInputs */

const vi_lot_items_lot_picker_placeholder = /** @type {(inputs: Lot_Items_Lot_Picker_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm lô...`)
};

/**

* @param {Lot_Items_Lot_Picker_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_items_lot_picker_placeholder = /** @type {((inputs?: Lot_Items_Lot_Picker_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Items_Lot_Picker_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_items_lot_picker_placeholder(inputs)
});